import { createFileRoute } from '@tanstack/react-router'
import { DashboardPage } from '#pages/client/DashboardPage'

export const Route = createFileRoute('/_app/')({
  component: DashboardPage,
})
